module.exports = __webpack_public_path__ + "img/07893f3.png";